"use strict";

import loadScript from '@elements/load-script';
import {getConfigValue, requireConfigValues} from '@elements/config-utils';

export function initInScope ($scope) {

    loadScript('https://www.google.com/recaptcha/api.js?render='+ getConfigValue('recaptchaSitekey')).then(() => {
        grecaptcha.ready(function() {
            let recaptchaAction =  document.getElementById('g-recaptcha-action');
            // do request for recaptcha token
            // response is promise with passed token
            grecaptcha.execute(getConfigValue('recaptchaSitekey'), {action:recaptchaAction.value})
                .then(function(token) {
                    // add token value to form
                    document.getElementById('g-recaptcha-response').value = token;
                });
        });
    }).catch(console.error);

}
